import React, { useEffect, useState } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { Table } from '@tiptap/extension-table';
import { TableRow } from '@tiptap/extension-table-row';
import { TableCell } from '@tiptap/extension-table-cell';
import { TableHeader } from '@tiptap/extension-table-header';

export default function RichTextEditor(props) {
  const [initialized, setInitialized] = useState(false);

  const editor = useEditor({
    extensions: [
      StarterKit,
      Table.configure({ resizable: false }),
      TableRow,
      TableCell,
      TableHeader,
    ],
    content: props.value ?? '',
    editable: !props.readOnly,
    editorProps: {
      attributes: {
        spellcheck: 'true',
        style: 'min-height: 440px; padding: 12px; outline: none; font-size: 14px; line-height: 1.6;',
      },
    },
    onBlur({ editor }) {
      props.onChange(editor.getHTML());
    },
  });

  useEffect(() => {
    if (!editor) return;
    if (!initialized) { setInitialized(true); return; }
    const current = editor.getHTML();
    if (current !== props.value) {
      editor.commands.setContent(props.value ?? '', false);
    }
  }, [props.value, props.readOnly]);

  useEffect(() => {
    if (editor) editor.setEditable(!props.readOnly);
  }, [props.readOnly]);

  const btn = (label, action, active) => (
    <button
      type="button"
      onMouseDown={e => { e.preventDefault(); action(); }}
      style={{ padding: '3px 8px', border: '1px solid #ccc', borderRadius: '3px', background: active ? '#e0e0e0' : 'white', cursor: 'pointer', fontSize: '12px' }}
    >{label}</button>
  );

  return (
    <div style={{ border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden' }}>
      {!props.readOnly && editor && (
        <div style={{ display: 'flex', gap: '4px', padding: '6px 8px', borderBottom: '1px solid #ccc', background: '#f9f9f9', flexWrap: 'wrap' }}>
          {btn('B', () => editor.chain().focus().toggleBold().run(), editor.isActive('bold'))}
          {btn('I', () => editor.chain().focus().toggleItalic().run(), editor.isActive('italic'))}
          {btn('S', () => editor.chain().focus().toggleStrike().run(), editor.isActive('strike'))}
          <span style={{ borderLeft: '1px solid #ccc', margin: '0 4px' }}></span>
          {btn('H1', () => editor.chain().focus().toggleHeading({ level: 1 }).run(), editor.isActive('heading', { level: 1 }))}
          {btn('H2', () => editor.chain().focus().toggleHeading({ level: 2 }).run(), editor.isActive('heading', { level: 2 }))}
          <span style={{ borderLeft: '1px solid #ccc', margin: '0 4px' }}></span>
          {btn('•', () => editor.chain().focus().toggleBulletList().run(), editor.isActive('bulletList'))}
          {btn('1.', () => editor.chain().focus().toggleOrderedList().run(), editor.isActive('orderedList'))}
          <span style={{ borderLeft: '1px solid #ccc', margin: '0 4px' }}></span>
          {btn('Tabla', () => editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run(), false)}
          {btn('+col', () => editor.chain().focus().addColumnAfter().run(), false)}
          {btn('-col', () => editor.chain().focus().deleteColumn().run(), false)}
          {btn('+fila', () => editor.chain().focus().addRowAfter().run(), false)}
          {btn('-fila', () => editor.chain().focus().deleteRow().run(), false)}
          <span style={{ borderLeft: '1px solid #ccc', margin: '0 4px' }}></span>
          {btn('↩', () => editor.chain().focus().undo().run(), false)}
          {btn('↪', () => editor.chain().focus().redo().run(), false)}
        </div>
      )}
      <EditorContent editor={editor} />
      <style>{`
        .ProseMirror table { border-collapse: collapse; width: 100%; margin: 8px 0; }
        .ProseMirror td, .ProseMirror th { border: 1px solid #ccc; padding: 6px 10px; min-width: 60px; }
        .ProseMirror th { background: #f0f0f0; font-weight: 600; }
      `}</style>
    </div>
  );
}
